var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodThyroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 93.5",
    style: {
      enableBackground: "new 0 0 68 93.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECBD65;}\n\t.st1{fill:#F8A087;}\n\t.st2{fill:#B72A5C;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:0.663;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.2,
    cy: 32.6,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.8,
    cy: 19.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 44.3,
    cy: 18.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42,
    cy: 25,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.5,
    cy: 30.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36.1,
    cy: 24.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34,
    cy: 4.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.9,
    cy: 21.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.2,
    cy: 26.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 17.1,
    cy: 27.5,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 58,
    cy: 34.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 37.7,
    cy: 20,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49.2,
    cy: 25.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.8,
    cy: 11.3,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.6,
    cy: 9.3,
    r: 2.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34,91.6c17.6,0,31.9-14.1,31.9-31.6c0-17.4-14.3-31.6-31.9-31.6S2.1,42.6,2.1,60C2.1,77.4,16.4,91.6,34,91.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.4,44.3c0,0,3-3.7,6.1,0.2s5.2,12.6,7,12.2c1.8-0.4,1-7.8,4.8-7.8s2.5,7.8,4.8,7.8S43.5,42.8,49,42.8 s6.1,10.7,5.5,15s-3.7,20-10.4,20.3s-0.1-8.5-9.9-8.5s-3.4,8.5-9.9,8.5S14.2,62.3,13.5,56.9C12.8,51.4,14.3,47.1,16.4,44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.6,45.8c0,0,4.3,1.4,5.1,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.4,54.3c0,0,4.9-2.3,9.5,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.8,46.7c0,0-3.9,1.4-4.3,6.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25.7,50.8c0,0-4.7,3.4-1.7,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M13.5,56.9c0,0,6.1-0.2,8.5,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.6,62.7c0,0,3.7,0.9,7.4,3.2s-3.4,7.5-3.4,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.7,55c0,0-2.6,6.2,2.6,8.3c0,0,0.4,4.4,2.6,6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.1,64.4c0,0,2-4.3,7.8-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.1,67.3c0,0,2.2-4.8,4.7-5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31,66.8c0,0-4.9,1.6-8,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.6,75.4c0,0-0.2-1.1-1.8-2.7c-1.6-1.6-0.7-4.7-0.7-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.3,63.3c0,0,4.7-3.1,0.1-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.1,52.7c0,0,4.1,0.8,6.6,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.2,69.6c0,0,2.6-1.9,3.1-7c0.5-5.1,1.7-6,1.7-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.1,57.7c0,0,1.9,2.4,5.3,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.1,54.1c0,0,2.6,2.4,1.1,6.5c-1.4,4.1-5.1,3.5-5.1,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.3,45.1c0,0,3.8,2.2,3.9,4.1c0.1,2-3.1,5.5,5.3,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.6,50.7c0,0,4.5,1.3,4.3,8.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.2,49.3c0,0,2.1-3.6,3.7-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.5,55c0,0,1.1-1.8,2.2-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.7,58.4c0,0,4.6,0.3,6.1,2c0,0,1.9,3.7,4.1,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.6,63.2c0,0,3.3,4.2-2.8,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.5,65.5c0,0,2.9,0.6,4.4-0.8c1.5-1.4,2.8-4.3,2.8-4.3s2.1-2.2,5.2-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,65.3c-0.4,6.1-4.6,7.9-4.6,7.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.2,75.6c0,0-1-4.2-4.1-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.9,64.7c0,0,5.1,3.4,5,6.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodThyroid);
export default __webpack_public_path__ + "static/media/Blood_Thyroid.5c19ea8bcb2453bf3097d52dcbbc1495.svg";
export { ForwardRef as ReactComponent };